import { RootState } from "@app/redux/root-reducer";

export const selectBrandState = (store: RootState) => store.brand.brand;

export const selectAddBrandName = (store: RootState) =>
  store.brand.addBrand;

export const selectDeleteBrandState = (store: RootState) =>
  store.brand.deleteBrand;